<template>
  <BModal
    id="modal-success-topup"
    ref="modal-success-topup"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    size="md"
  >
    <div
      class="position-absolute"
      style="right: 15px; top: 15px;"
    >
      <feather-icon
        icon="XIcon"
        class="cursor-pointer"
        @click="closeModal"
      />
    </div>

    <template v-if="transaction">
      <div
        ref="receiptContent"
        class="receipt-content"
      >
        <BRow>
          <BCol
            cols="12"
            class="text-center"
          >
            <div class="canvas-container">
              <img
                src="https://storage.googleapis.com/komerce/assets/icons/Checklist-fill.svg"
                alt="Check"
                width="24"
                height="24"
                crossorigin="anonymous"
              >
              <h4
                class="text-black font-weight-bold m-0 inline-block float-left"
              >
                {{
                  source === 'topup'
                    ? 'Top Up Berhasil'
                    : 'Berhasil Berlangganan'
                }}
              </h4>
            </div>
          </BCol>
        </BRow>

        <BRow class="mt-2">
          <BCol class="d-flex justify-content-between">
            <h5 class="text-black font-weight-bold">
              Detail Transaksi
            </h5>
            <div class="d-flex align-items-center gap-[4px]">
              <img
                v-if="getPlatformIcon()"
                :src="getPlatformIcon()"
                :alt="transaction.platform_name"
                width="16"
                height="16"
                crossorigin="anonymous"
              >
              <img
                v-if="transaction.platform_name === 'meta' && transaction.ad_account_type === 'cpas'"
                src="https://storage.googleapis.com/komerce/komads-meta/shopee.svg"
                :alt="`${transaction.platform_name}-${transaction.ad_account_type}`"
                width="16"
                height="16"
              >
              <span class="text-black text-bold capitalize">{{ transaction.platform_name }} {{ transaction.ad_account_type }}</span>
            </div>
          </BCol>
        </BRow>
        <hr class="my-1">

        <!-- Detail Transaksi -->
        <BRow class="mt-2">
          <BCol cols="12">
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">Tanggal Topup</span>
              <span class="text-black">{{
                formatDate(transaction.created_at)
              }}</span>
            </div>
            <div
              v-if="transaction.status === 'success'"
              class="d-flex justify-content-between mb-2"
            >
              <span class="text-secondary">Tanggal Diproses</span>
              <span class="text-black">{{
                formatDate(transaction.updated_at)
              }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">Id Transaksi</span>
              <span class="text-black">{{ transaction.transaction_id }}</span>
            </div>
            <div class="d-flex justify-content-between mb-2">
              <span class="text-secondary">Email</span>
              <span class="text-black">{{ transaction.partner_email }}</span>
            </div>
            <template v-if="source === 'topup'">
              <div class="d-flex justify-content-between mb-2">
                <span class="text-secondary">Akun WL tujuan</span>
                <span class="text-black">{{
                  transaction.whitelist_account_name
                }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-secondary">Nominal top up</span>
                <span class="text-black">{{
                  IDR(transaction.amount_topup)
                }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span
                  class="text-secondary"
                >Top up fee ({{ transaction.fee_topup }}%)</span>
                <span class="text-black" />
              </div>
              <hr class="my-1">
              <div class="d-flex justify-content-between mb-2">
                <span class="text-secondary">• Fee</span>
                <span class="text-black">{{
                  IDR(transaction.amount_fee)
                }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-secondary">• PPN</span>
                <span class="text-black">{{
                  IDR(transaction.amount_tax)
                }}</span>
              </div>
              <hr class="mb-2">
              <div class="d-flex justify-content-between">
                <span
                  class="text-black font-weight-bold"
                >Total dibayarkan</span>
                <span class="text-black font-weight-bold">{{
                  IDR(transaction.amount_total)
                }}</span>
              </div>
            </template>
            <template v-else-if="source === 'subscription'">
              <div class="d-flex justify-content-between mb-2">
                <span class="text-secondary">Masa Berlaku</span>
                <span
                  class="text-black"
                >{{ DDMMYYYY(transaction.subscription_data.created_at) }} -
                  {{ DDMMYYYY(transaction.subscription_data.expired_at) }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-secondary">Nominal</span>
                <span class="text-black">{{
                  IDR(transaction.subscription_data.nominal)
                }}</span>
              </div>
            </template>
          </BCol>
        </BRow>
      </div>

      <!-- Download Button -->
      <BRow class="mt-1">
        <BCol
          cols="12"
          class="text-center"
        >
          <BButton
            variant="link"
            class="text-danger p-0"
            @click="downloadReceipt"
          >
            Download Bukti Transaksi
          </BButton>
        </BCol>
      </BRow>

      <!-- Action Buttons -->
      <div class="my-2 flex flex-row gap-4">
        <BButton
          variant="outline-success"
          class="rounded-lg d-flex align-items-center justify-content-center grow"
          @click="shareTransaction"
        >
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/whatsapp.svg"
            alt="whatsapp"
            width="16"
            height="16"
            class="mr-2"
            crossorigin="anonymous"
          >
          Bagikan
        </BButton>
        <BButton
          variant="primary"
          class="rounded-lg grow"
          @click="viewHistory"
        >
          Riwayat {{ source === 'topup' ? 'Top Up' : 'Langganan' }}
        </BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
import moment from 'moment'

import { IDR } from '@/libs/currency'
import html2canvas from 'html2canvas'
import { DDMMYYYY } from '@/libs/formatDate'

export default {
  props: {
    transaction: {
      type: Object,
      default: null,
    },
    source: {
      type: String,
      default: 'topup',
    },
  },
  data() {
    return {
      IDR,
      DDMMYYYY,
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD MMMM YYYY | HH:mm [WIB]')
    },
    getPlatformIcon() {
      if (!this.transaction) return ''
      const platformIcons = {
        meta: 'https://storage.googleapis.com/komerce/komads-meta/meta.svg',
        google:
          'https://storage.googleapis.com/komerce/komads-meta/googles.png',
        tiktok: 'https://storage.googleapis.com/komerce/komads-meta/tiktod.svg',
      }

      // Handle different platform name formats from API
      const platformName = this.transaction.platform_name.toLowerCase()

      return platformIcons[platformName] || ''
    },
    /**
     * Close the modal
     */
    closeModal() {
      this.$refs['modal-success-topup'].hide()
    },

    /**
     * Download transaction receipt
     */
    downloadReceipt() {
      this.captureReceiptAsImage()
    },

    /**
     * Get html2canvas configuration
     * @returns {Object} html2canvas configuration object
     */
    getHtml2CanvasConfig() {
      return {
        backgroundColor: '#ffffff',
        scale: 3,
        logging: false,
        useCORS: true,
        ignoreElements: element => element.classList && element.classList.contains('no-capture'),
        onclone: document => {
          // Pastikan gambar memiliki layout yang benar saat cloning
          const images = document.querySelectorAll('img')
          images.forEach(img => {
            const imgStyle = img.cloneNode()
            imgStyle.style.verticalAlign = 'middle'
            imgStyle.style.display = 'inline-block'
            imgStyle.style.marginTop = '15px'
            imgStyle.style.top = '8px'
            imgStyle.style.textAlign = 'center'
            img.parentNode.replaceChild(imgStyle, img)
          })
        },
      }
    },

    /**
     * Get receipt element and validate it exists
     * @returns {HTMLElement|null} Receipt element or null if not found
     */
    getReceiptElement() {
      const receiptElement = this.$refs.receiptContent

      if (!receiptElement) {
        this.$toast_error({
          message: 'Tidak dapat mengambil gambar bukti transaksi',
        })
        return null
      }

      return receiptElement
    },

    /**
     * Capture receipt element as canvas
     * @returns {Promise<HTMLCanvasElement|null>} Canvas element or null if error
     */
    async captureReceiptToCanvas() {
      const receiptElement = this.getReceiptElement()
      if (!receiptElement) return Promise.resolve(null)

      return html2canvas(receiptElement, this.getHtml2CanvasConfig()).catch(
        error => {
          console.error('Error capturing receipt:', error)
          this.$toast_error({
            message: 'Gagal mengambil gambar bukti transaksi',
          })
          return null
        },
      )
    },

    /**
     * Add watermark to canvas and return a promise with the processed canvas
     * @param {HTMLCanvasElement} canvas - Canvas element to add watermark to
     * @returns {Promise<HTMLCanvasElement>} Canvas with watermark
     */
    addWatermarkToCanvas(canvas) {
      return new Promise(resolve => {
        if (!canvas) {
          resolve(null)
          return
        }

        // Add watermark
        const ctx = canvas.getContext('2d')

        // Load watermark image
        const watermarkImg = new Image()
        watermarkImg.crossOrigin = 'Anonymous'
        watermarkImg.src = 'https://storage.googleapis.com/komerce/komads-meta/bg_receipt.svg'

        watermarkImg.onload = () => {
          // Set opacity for the watermark
          ctx.globalAlpha = 0.7

          // Draw watermark to cover the entire canvas
          ctx.drawImage(watermarkImg, 0, 0, canvas.width, canvas.height)

          // Reset global alpha
          ctx.globalAlpha = 1.0

          resolve(canvas)
        }

        watermarkImg.onerror = () => {
          console.error('Error loading watermark image')
          // Return the original canvas if watermark fails to load
          resolve(canvas)
        }
      })
    },

    /**
     * Capture receipt content as image using html2canvas
     * This method captures only the receipt content without action buttons
     */
    captureReceiptAsImage() {
      this.captureReceiptToCanvas()
        .then(canvas => this.addWatermarkToCanvas(canvas))
        .then(canvas => {
          if (!canvas) return

          // Convert canvas to image data URL
          const imageData = canvas.toDataURL('image/png')

          // Create download link
          const downloadLink = document.createElement('a')
          downloadLink.href = imageData
          downloadLink.download = `bukti-transaksi-${this.transaction.transaction_id}.png`

          // Trigger download
          document.body.appendChild(downloadLink)
          downloadLink.click()
          document.body.removeChild(downloadLink)

          this.$toast_success({ message: 'Bukti transaksi berhasil diunduh' })
        })
    },

    /**
     * Share transaction via Web Share API or WhatsApp
     */
    shareTransaction() {
      this.captureReceiptToCanvas()
        .then(canvas => this.addWatermarkToCanvas(canvas))
        .then(canvas => {
          if (!canvas) return

          // Mengkonversi canvas ke data URL
          canvas.toBlob(
            blob => {
              const file = new File(
                [blob],
                `bukti-topup-${this.transaction.id}.png`,
                {
                  type: 'image/png',
                },
              )

              // Menggunakan Web Share API untuk berbagi file
              if (navigator.canShare && navigator.canShare({ files: [file] })) {
                this.shareViaWebShareAPI(file)
              } else {
                // Fallback ke WhatsApp jika Web Share API tidak didukung
                this.shareViaWhatsApp()
              }
            },
            'image/png',
            1.0,
          )
        })
        .catch(error => {
          console.error('Error capturing receipt for sharing:', error)
          this.$toast_error({ message: 'Gagal membagikan bukti transaksi' })
          // Fallback ke WhatsApp jika terjadi error
          this.shareViaWhatsApp()
        })
    },

    /**
     * Share transaction via Web Share API
     * @param {File} file - File to share
     */
    shareViaWebShareAPI(file) {
      navigator
        .share({
          title: 'Bukti Top Up Whitelisted',
          text: `Top Up Whitelisted berhasil! Nominal: ${IDR(
            this.transaction.amount_topup,
          )}, Total: ${IDR(this.transaction.amount_total)}`,
          url: window.location.href,
          files: [file],
        })
        .then(() => {
          this.$toast_success({
            message: 'Berhasil membagikan bukti transaksi',
          })
        })
        .catch(error => {
          console.error('Error sharing:', error)
          this.shareViaWhatsApp()
        })
    },

    /**
     * Share transaction via WhatsApp (fallback method)
     */
    shareViaWhatsApp() {
      const text = `Top Up Whitelisted berhasil! Nominal: ${IDR(
        this.transaction.amount_topup,
      )}, Total: ${IDR(this.transaction.amount_total)}`
      const url = `https://wa.me/?text=${encodeURIComponent(text)}`
      window.open(url, '_blank')
    },

    /**
     * Navigate to transaction history
     */
    viewHistory() {
      if (this.source === 'topup') {
        this.$router.push({ name: 'whitelisted-account' })
      } else if (this.source === 'subscription') {
        const postMessage = {
          route: `/komads/whitelisted-account/?platform=${this.transaction.platform_name}`,
        }
        const iframe = document.querySelector('#whitelisted-komads')
        iframe.contentWindow.postMessage(postMessage, '*')
      }
      this.closeModal()
    },
  },
}
</script>

<style lang="css" scoped>
.cursor-pointer {
  cursor: pointer;
}

.receipt-content {
  padding: 16px;
  background-color: #ffffff;
}
.canvas-container {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}
.canvas-container img {
  vertical-align: middle;
  display: inline-block;
  position: relative;
  top: 0;
  margin-top: 0 !important;
}
/* Responsive styles */
@media (max-width: 576px) {
  .modal-dialog {
    margin: 0.5rem;
  }
}
</style>
